/* Lunar Haus — interaction layer. Vanilla, deferred, no libraries. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Scroll reveal (staggered) ---------- */
  function initReveal() {
    var els = Array.prototype.slice.call(document.querySelectorAll('.reveal'));
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var delay = parseInt(el.getAttribute('data-reveal-delay') || '0', 10);
        if (delay) el.style.transitionDelay = (delay * 90) + 'ms';
        el.classList.add('is-in');
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Header transparent -> solid on scroll ---------- */
  function initHeader() {
    var header = document.querySelector('.lh-header');
    if (!header) return;
    if (!document.body.classList.contains('has-transparent-header')) return;
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 40);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Mobile nav ---------- */
  function initNav() {
    var burger = document.querySelector('.lh-burger');
    var nav = document.getElementById('lh-nav');
    if (!burger || !nav) return;
    burger.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      burger.classList.toggle('is-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    nav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        nav.classList.remove('is-open'); burger.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ---------- Article TOC: build from H2/H3, scrollspy ---------- */
  function slugify(s, used) {
    var base = (s || 'section').toLowerCase().replace(/[^\w\s-]/g, '').trim().replace(/\s+/g, '-').replace(/-+/g, '-') || 'section';
    var slug = base, i = 2;
    while (used[slug]) { slug = base + '-' + i; i++; }
    used[slug] = true;
    return slug;
  }
  function initTOC() {
    var body = document.querySelector('[data-toc-source]');
    var toc = document.querySelector('[data-toc]');
    if (!body || !toc) return;
    var heads = Array.prototype.slice.call(body.querySelectorAll('h2, h3'));
    if (heads.length < 2) { toc.parentNode && toc.parentNode.classList.add('lh-toc--empty'); toc.closest('.lh-toc') && (toc.closest('.lh-toc').style.display = 'none'); rebalanceLayout(); return; }
    var used = {};
    var list = document.createElement('ul');
    list.className = 'lh-toc__list';
    var links = [];
    heads.forEach(function (h) {
      if (!h.id) h.id = slugify(h.textContent, used);
      var li = document.createElement('li');
      if (h.tagName === 'H3') li.className = 'lh-toc--h3';
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      li.appendChild(a);
      list.appendChild(li);
      links.push({ a: a, h: h });
    });
    toc.appendChild(list);

    // smooth scroll handled by CSS scroll-behavior; just update hash
    var byId = {};
    links.forEach(function (l) { byId[l.h.id] = l.a; });

    if ('IntersectionObserver' in window) {
      var current = null;
      var spy = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            if (current) current.classList.remove('is-current');
            var a = byId[e.target.id];
            if (a) { a.classList.add('is-current'); current = a; }
          }
        });
      }, { rootMargin: '-12% 0px -70% 0px', threshold: 0 });
      heads.forEach(function (h) { spy.observe(h); });
    }

    // mobile collapse toggle
    var wrap = toc.closest('.lh-toc');
    var toggle = wrap && wrap.querySelector('.lh-toc__toggle');
    if (toggle) {
      toggle.addEventListener('click', function () {
        var open = wrap.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  }
  function rebalanceLayout() {
    // if TOC hidden, let the layout center the body
    var layout = document.querySelector('.lh-article__layout');
    if (layout) layout.style.gridTemplateColumns = 'minmax(0, var(--maxw-read))';
  }

  /* ---------- Category filter (blog landing) ---------- */
  function initFilter() {
    var bar = document.querySelector('[data-filter]');
    if (!bar) return;
    var cards = Array.prototype.slice.call(document.querySelectorAll('[data-card-tags]'));
    var btns = Array.prototype.slice.call(bar.querySelectorAll('.lh-filter__btn'));
    var empty = document.querySelector('[data-filter-empty]');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tag = btn.getAttribute('data-filter-tag');
        btns.forEach(function (b) { b.classList.toggle('is-active', b === btn); b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        var shown = 0;
        cards.forEach(function (c) {
          var tags = (c.getAttribute('data-card-tags') || '').split('|');
          var match = tag === 'all' || tags.indexOf(tag) !== -1;
          c.classList.toggle('is-hidden', !match);
          if (match) shown++;
        });
        if (empty) empty.style.display = shown ? 'none' : 'block';
        if (history.replaceState) {
          var url = tag === 'all' ? location.pathname : location.pathname + '?c=' + encodeURIComponent(tag);
          history.replaceState(null, '', url);
        }
      });
    });
    // honour ?c= on load
    var params = new URLSearchParams(location.search);
    var pre = params.get('c');
    if (pre) {
      var target = btns.filter(function (b) { return b.getAttribute('data-filter-tag') === pre; })[0];
      if (target) target.click();
    }
  }

  /* ---------- FAQ accordion ---------- */
  function initFAQ() {
    document.querySelectorAll('.lh-faq__item').forEach(function (item) {
      var q = item.querySelector('.lh-faq__q');
      var a = item.querySelector('.lh-faq__a');
      if (!q || !a) return;
      q.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        q.setAttribute('aria-expanded', open ? 'true' : 'false');
        a.style.maxHeight = open ? a.scrollHeight + 'px' : '0px';
      });
    });
  }

  /* ---------- Predictive search ---------- */
  function escHtml(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function initSearch() {
    var toggle = document.querySelector('.lh-search-toggle');
    var overlay = document.getElementById('lh-search');
    if (!toggle || !overlay) return;
    var input = overlay.querySelector('.lh-search__input');
    var results = overlay.querySelector('[data-search-results]');
    var closeBtn = overlay.querySelector('.lh-search__close');
    var hintHtml = '<p class="lh-search__hint">Try “new moon ritual”, “crystals for sleep”, or a zodiac sign.</p>';

    function open() {
      overlay.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      toggle.setAttribute('aria-expanded', 'true');
      // force reflow so the opacity transition runs
      void overlay.offsetWidth;
      overlay.classList.add('is-open');
      if (!results.innerHTML) results.innerHTML = hintHtml;
      setTimeout(function () { input.focus(); }, 60);
    }
    function close() {
      overlay.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      toggle.setAttribute('aria-expanded', 'false');
      setTimeout(function () { overlay.hidden = true; }, 280);
    }
    toggle.addEventListener('click', open);
    closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.hidden) close(); });

    var timer, lastQ = '';
    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (q === lastQ) return;
      lastQ = q;
      clearTimeout(timer);
      if (q.length < 2) { results.innerHTML = hintHtml; return; }
      timer = setTimeout(function () { run(q); }, 220);
    });

    function run(q) {
      var url = '/search/suggest.json?q=' + encodeURIComponent(q)
        + '&resources[type]=article,page&resources[limit]=8'
        + '&resources[options][unavailable_products]=last&resources[options][fields]=title,body,author,tag';
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (input.value.trim() !== q) return; // stale
          render(q, (data.resources && data.resources.results) || {});
        })
        .catch(function () {});
    }

    function render(q, res) {
      var arts = res.articles || [];
      var pages = res.pages || [];
      var all = arts.concat(pages);
      if (!all.length) {
        results.innerHTML = '<p class="lh-search__empty">No results for “' + escHtml(q) + '” yet. The library is still growing.</p>';
        return;
      }
      var html = '<ul class="lh-search__list">';
      all.forEach(function (a) {
        var thumb = a.image
          ? '<span class="lh-search__thumb"><img src="' + a.image + '" alt="" loading="lazy"></span>'
          : '<span class="lh-search__thumb"></span>';
        html += '<li><a href="' + a.url + '">' + thumb + '<span class="lh-search__t">' + escHtml(a.title) + '</span></a></li>';
      });
      html += '</ul>';
      html += '<a class="lh-search__all" href="/search?type=article&q=' + encodeURIComponent(q) + '">View all results →</a>';
      results.innerHTML = html;
    }
  }

  function init() {
    initReveal(); initHeader(); initNav(); initTOC(); initFilter(); initFAQ(); initSearch();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
